import {g} from 'xojs/lib/runtime/getGlobal';
import {variables} from '@xo-union/tk-ui-breakpoints';

const isMobile = () =>
  !g.matchMedia ? true : g.matchMedia(`(${variables.inMobile})`).matches;

export default isMobile;
